import React from 'react';

const ConfirmInformationOnFileAlert = () => (
  <va-alert status="warning">
    <h2 slot="headline">Confirm we have information on file</h2>
    <p className="vads-u-margin-bottom--0">
      We can only process updates if we already have information on file about
      the person who needs or gets CHAMPVA benefits.
    </p>
  </va-alert>
);

export default ConfirmInformationOnFileAlert;
